import React, {useState, useEffect} from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button, Label,
} from 'reactstrap';
import {connect} from 'react-redux';
import {createEngineer} from '../../store/engineer/actions';
import {Link, useNavigate} from 'react-router-dom';
import {SweetAlert} from '../../components/Common/SweetAlert';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import {apiError} from '../../store/auth/login/actions';
import ListDealers from '../../components/Lists/ListDealers';
import FormField from '../../components/Common/FormField';
import {FormProvider, useForm} from 'react-hook-form';

const EngineerAdd = (props) => {
  const [errorMsg, setErrorMsg] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const form = useForm();
  const {
    handleSubmit,
  } = form;

  useEffect(() => {
    setIsLoading(false);
    if (props.data && props.data.success) {
      setSuccessMsg(true);
    } else if (props.data && props.data.error) {
      setErrorMsg(props.data.error);
    }
  }, [props.data]);

  function handleValidSubmit(values) {
    setIsLoading(true);

    const member = {
      firstname: values.firstname,
      lastname: values.lastname,
      position: values.position,
      dealer_id: values.dealer,
      email: values.email,
      phone: values.phone,
    };
    props.createEngineer(member);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>

          <Breadcrumbs
            parent="/members"
            title="Members"
            breadcrumbItem="Add Member"
          />
          <Row>
            <Col xs="12">
              <FormProvider {...form}>
                <form
                  className="form-horizontal"
                  onSubmit={handleSubmit(handleValidSubmit)}
                >
                  {errorMsg ?
                    <SweetAlert
                      title="Error!"
                      danger
                      showConfirm={true}
                      showCancel={false}
                      confirmBtnBsStyle="danger"
                      closeOnConfirm={true}
                      onConfirm={() => {
                        setErrorMsg(false);
                      }}
                    >
                      {errorMsg}
                    </SweetAlert> : ''
                  }
                  {successMsg ? <SweetAlert
                    title="Good job!"
                    success
                    showConfirm={true}
                    showCancel={false}
                    confirmBtnBsStyle="yellow"
                    onConfirm={() => {
                      navigate('/members');
                    }}
                  >
                    The member has been added!
                  </SweetAlert> : null}
                  <Card>
                    <CardBody>
                      <CardTitle>Member Informations</CardTitle>
                      <CardSubtitle className="mb-3">
                        Fill all information below
                      </CardSubtitle>
                      <Row>
                        <Col md="3">
                          <FormField
                            name="firstname"
                            className="form-control"
                            placeholder="Firstname *"
                            label="Firstname"
                            type="text"
                            validate={{required: {value: true}}}
                            errorMessage="Please provide a valid firstname."
                          />
                        </Col>
                        <Col md="3">
                          <FormField
                            name="lastname"
                            className="form-control"
                            placeholder="Lastname *"
                            label="Lastname"
                            type="text"
                            validate={{required: {value: true}}}
                            errorMessage="Please provide a valid lastname."
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md="3">
                          <FormField
                            name="position"
                            className="form-control"
                            placeholder="Position *"
                            label="Position"
                            type="text"
                            validate={{required: {value: true}}}
                            errorMessage="Please provide a valid position."
                          />
                        </Col>
                        <Col md="3">
                          <div className="form-group">
                            <Label htmlFor="dealer">Dealer</Label>
                            <ListDealers required={true}/>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="4">
                          <FormField
                            name="email"
                            value=""
                            className="form-control"
                            placeholder="Email Address*"
                            label="Email"
                            type="text"
                            validate={{required: {value: true}}}
                            errorMessage="Please provide a valid email address."
                          />
                        </Col>
                        <Col md="3">
                          <FormField
                            name="phone"
                            value=""
                            className="form-control"
                            placeholder="Phone *"
                            label="Phone"
                            type="text"
                            validate={{required: {value: true}}}
                            errorMessage="Please provide a valid phone number."
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>

                  <Row className="my-4">
                    <Col sm="6">
                      <Link to="/members"
                        className="btn d-none d-sm-inline-block btn-link">
                        <i className="mdi mdi-arrow-left mr-1"/>
                        Back to Members Overview
                      </Link>
                    </Col>
                    <Col sm="6">
                      <div className="text-sm-right">
                        {isLoading ?
                          <Button
                            className="btn btn-yellow"
                            type="submit"
                            disabled={true}
                          >
                            <i
                              className="bx bx-loader bx-spin font-size-16
                            align-middle mr-2">

                            </i>
                            Submit Member
                          </Button> :
                          <Button className="btn btn-yellow" type="submit">
                            <i className="mdi mdi-plus-thick mr-1"/>
                            Submit Member
                          </Button>
                        }
                      </div>
                    </Col>
                  </Row>

                </form>
              </FormProvider>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};


const mapStatetoProps = (state) => {
  const {data} = state.Engineer;
  state.Engineer = {};
  return {data};
};

export default connect(
    mapStatetoProps, {createEngineer, apiError},
)(EngineerAdd);
